var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cxm-Rating"},_vm._l((_vm.stars),function(star){return _c('div',{key:star,staticClass:"cxm-Rating-Star",class:{ '-selected': _vm.steps >= star }},[_c('Icon',{attrs:{"name":"star","size":_vm.size,"handle-click":() => _vm.handleAnswerChange(star)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }